/**
 * @generated SignedSource<<58df27de5a6006666ee0de841abcf3b0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SubscriptionTypeEnum = "Expired" | "FreemiumOrg" | "LegacyPrePaywall" | "PaidBillingGroup" | "PaidOrgPro" | "PaidTeamPro" | "PaidUserPro" | "SelfServePremiumOrgQ42020" | "SelfServePremiumTeamQ12021" | "%future added value";
export type UrnType = "Date" | "Email" | "Event" | "FlowState" | "Guest" | "Org" | "Phone" | "Services" | "Setting" | "Team" | "Teammate" | "TimeZone" | "User" | "WorkOsOrg" | "WorkingGroup" | "WorkingHours" | "%future added value";
export type UserStatusEnum = "Active" | "Preview" | "Restricted" | "%future added value";
export type SudoResetFlowStateMutationInput = {
  clientMutationId?: string | null;
  flowKey: string;
  orgRelayId?: string | null;
};
export type SudoResetFlowStateMutation$variables = {
  input: SudoResetFlowStateMutationInput;
};
export type SudoResetFlowStateMutation$data = {
  readonly sudoResetFlowState: {
    readonly clientMutationId: string | null;
    readonly viewer: {
      readonly id: string;
      readonly sudo: {
        readonly resetFlowState: {
          readonly id: string;
          readonly flowKey: string | null;
          readonly current: {
            readonly id: string;
            readonly state: string | null;
            readonly percentComplete: number | null;
            readonly errorMessage: string | null;
          } | null;
          readonly pending: {
            readonly id: string;
            readonly state: string | null;
            readonly percentComplete: number | null;
            readonly errorMessage: string | null;
          } | null;
        } | null;
        readonly modifyUser: {
          readonly user: {
            readonly id: string;
            readonly givenName: string | null;
            readonly familyName: string | null;
            readonly emails: ReadonlyArray<string>;
            readonly status: UserStatusEnum | null;
            readonly externalImageUrl: string | null;
            readonly flowStates: {
              readonly edges: ReadonlyArray<{
                readonly node: {
                  readonly id: string;
                  readonly flowKey: string | null;
                  readonly current: {
                    readonly id: string;
                    readonly state: string | null;
                    readonly percentComplete: number | null;
                    readonly errorMessage: string | null;
                  } | null;
                  readonly pending: {
                    readonly id: string;
                    readonly state: string | null;
                    readonly percentComplete: number | null;
                    readonly errorMessage: string | null;
                  } | null;
                } | null;
              } | null> | null;
            } | null;
            readonly orgs: {
              readonly edges: ReadonlyArray<{
                readonly node: {
                  readonly id: string;
                  readonly name: string | null;
                  readonly flowStates: {
                    readonly edges: ReadonlyArray<{
                      readonly node: {
                        readonly id: string;
                        readonly flowKey: string | null;
                        readonly current: {
                          readonly id: string;
                          readonly state: string | null;
                          readonly percentComplete: number | null;
                          readonly errorMessage: string | null;
                        } | null;
                        readonly pending: {
                          readonly id: string;
                          readonly state: string | null;
                          readonly percentComplete: number | null;
                          readonly errorMessage: string | null;
                        } | null;
                      } | null;
                    } | null> | null;
                  } | null;
                } | null;
              } | null> | null;
            };
          } | null;
          readonly userTeams: {
            readonly __typename: "TeamList";
            readonly list: ReadonlyArray<{
              readonly teamId: string;
              readonly teamName: string;
            }>;
          } | {
            // This will never be '%other', but we need some
            // value in case none of the concrete values match.
            readonly __typename: "%other";
          } | null;
          readonly subscriptions: {
            readonly __typename: "PaymentSubscriptionList";
            readonly list: ReadonlyArray<{
              readonly id: string;
              readonly type: SubscriptionTypeEnum | null;
              readonly subjectUrn: {
                readonly value: string | null;
                readonly type: UrnType | null;
              };
            }>;
          } | {
            // This will never be '%other', but we need some
            // value in case none of the concrete values match.
            readonly __typename: "%other";
          } | null;
          readonly featureStatesJson: string | null;
        } | null;
      } | null;
    } | null;
  } | null;
};
export type SudoResetFlowStateMutation = {
  variables: SudoResetFlowStateMutation$variables;
  response: SudoResetFlowStateMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientMutationId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "state",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "percentComplete",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "errorMessage",
    "storageKey": null
  }
],
v5 = [
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "flowKey",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "FlowStatus",
    "kind": "LinkedField",
    "name": "current",
    "plural": false,
    "selections": (v4/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "FlowStatus",
    "kind": "LinkedField",
    "name": "pending",
    "plural": false,
    "selections": (v4/*: any*/),
    "storageKey": null
  }
],
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "FlowState",
  "kind": "LinkedField",
  "name": "resetFlowState",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v7 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000000
  }
],
v8 = {
  "alias": null,
  "args": (v7/*: any*/),
  "concreteType": "FlowStateConnection",
  "kind": "LinkedField",
  "name": "flowStates",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FlowStateEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FlowState",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v5/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "flowStates(first:1000000)"
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "givenName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "familyName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emails",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalImageUrl",
      "storageKey": null
    },
    (v8/*: any*/),
    {
      "alias": null,
      "args": (v7/*: any*/),
      "concreteType": "OrgConnection",
      "kind": "LinkedField",
      "name": "orgs",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OrgEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Org",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v3/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                (v8/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "orgs(first:1000000)"
    }
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "teamId",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "teamName",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "featureStatesJson",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SudoResetFlowStateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SudoResetFlowStateMutationPayload",
        "kind": "LinkedField",
        "name": "sudoResetFlowState",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Sudo",
                "kind": "LinkedField",
                "name": "sudo",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserAndExtendedInfo",
                    "kind": "LinkedField",
                    "name": "modifyUser",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "userTeams",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Team",
                                "kind": "LinkedField",
                                "name": "list",
                                "plural": true,
                                "selections": [
                                  (v11/*: any*/),
                                  (v12/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "TeamList",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "subscriptions",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PaymentSubscription",
                                "kind": "LinkedField",
                                "name": "list",
                                "plural": true,
                                "selections": [
                                  (v3/*: any*/),
                                  (v13/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Urn",
                                    "kind": "LinkedField",
                                    "name": "subjectUrn",
                                    "plural": false,
                                    "selections": [
                                      (v14/*: any*/),
                                      (v13/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "PaymentSubscriptionList",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SudoResetFlowStateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SudoResetFlowStateMutationPayload",
        "kind": "LinkedField",
        "name": "sudoResetFlowState",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Sudo",
                "kind": "LinkedField",
                "name": "sudo",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserAndExtendedInfo",
                    "kind": "LinkedField",
                    "name": "modifyUser",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "userTeams",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Team",
                                "kind": "LinkedField",
                                "name": "list",
                                "plural": true,
                                "selections": [
                                  (v11/*: any*/),
                                  (v12/*: any*/),
                                  (v3/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "TeamList",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "subscriptions",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PaymentSubscription",
                                "kind": "LinkedField",
                                "name": "list",
                                "plural": true,
                                "selections": [
                                  (v3/*: any*/),
                                  (v13/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Urn",
                                    "kind": "LinkedField",
                                    "name": "subjectUrn",
                                    "plural": false,
                                    "selections": [
                                      (v14/*: any*/),
                                      (v13/*: any*/),
                                      (v3/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "PaymentSubscriptionList",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2129682d917af7410c367e674048cb1f",
    "id": null,
    "metadata": {},
    "name": "SudoResetFlowStateMutation",
    "operationKind": "mutation",
    "text": "mutation SudoResetFlowStateMutation(\n  $input: SudoResetFlowStateMutationInput!\n) {\n  sudoResetFlowState(input: $input) {\n    clientMutationId\n    viewer {\n      id\n      sudo {\n        resetFlowState {\n          id\n          flowKey\n          current {\n            id\n            state\n            percentComplete\n            errorMessage\n          }\n          pending {\n            id\n            state\n            percentComplete\n            errorMessage\n          }\n        }\n        modifyUser {\n          user {\n            id\n            givenName\n            familyName\n            emails\n            status\n            externalImageUrl\n            flowStates(first: 1000000) {\n              edges {\n                node {\n                  id\n                  flowKey\n                  current {\n                    id\n                    state\n                    percentComplete\n                    errorMessage\n                  }\n                  pending {\n                    id\n                    state\n                    percentComplete\n                    errorMessage\n                  }\n                }\n              }\n            }\n            orgs(first: 1000000) {\n              edges {\n                node {\n                  id\n                  name\n                  flowStates(first: 1000000) {\n                    edges {\n                      node {\n                        id\n                        flowKey\n                        current {\n                          id\n                          state\n                          percentComplete\n                          errorMessage\n                        }\n                        pending {\n                          id\n                          state\n                          percentComplete\n                          errorMessage\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n          userTeams {\n            __typename\n            ... on TeamList {\n              list {\n                teamId\n                teamName\n                id\n              }\n            }\n          }\n          subscriptions {\n            __typename\n            ... on PaymentSubscriptionList {\n              list {\n                id\n                type\n                subjectUrn {\n                  value\n                  type\n                  id\n                }\n              }\n            }\n          }\n          featureStatesJson\n        }\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "025afda78353caa4f7f59c4a1e62d936";

export default node;
